import Layout from '@/layout';
import { PLAT_TYPE } from '@/utils/settingMer';

// 独立门店没有商户结算账户，保留已授权入口但不加载商户业务页面。
var merchantPage = function merchantPage(loader) {
  return PLAT_TYPE === 2 ? function () {
    return import('@/views/alliance/unavailable/index');
  } : loader;
};

/**
 * 校园收益联盟（商户端）。
 *
 * 后端是独立的 tjMall-alliance 模块，与商城淘客不是同一套账，
 * 所以单独一级菜单，不并进 distribution 里，免得两边的「佣金」被当成一回事。
 */
var allianceRouter = {
  path: '/alliance',
  component: Layout,
  redirect: '/alliance/overview',
  name: 'Alliance',
  meta: {
    title: '收益联盟',
    icon: 'clipboard'
  },
  children: [{
    path: 'overview',
    component: merchantPage(function () {
      return import('@/views/alliance/overview/index');
    }),
    name: 'AllianceMerchantOverview',
    meta: {
      title: '经营概览',
      icon: ''
    }
  }, {
    path: 'verify',
    component: merchantPage(function () {
      return import('@/views/alliance/verify/index');
    }),
    name: 'AllianceVerifyDesk',
    meta: {
      title: '核销台',
      icon: ''
    }
  }, {
    path: 'code',
    component: merchantPage(function () {
      return import('@/views/alliance/code/index');
    }),
    name: 'AllianceMerchantCode',
    meta: {
      title: '商户码',
      icon: ''
    }
  }, {
    path: 'records',
    component: merchantPage(function () {
      return import('@/views/alliance/records/index');
    }),
    name: 'AllianceVerifyRecords',
    meta: {
      title: '核销记录',
      icon: ''
    }
  }, {
    path: 'account',
    component: merchantPage(function () {
      return import('@/views/alliance/account/index');
    }),
    name: 'AllianceMerchantAccount',
    meta: {
      title: '积分账户',
      icon: ''
    }
  }, {
    path: 'bills',
    component: merchantPage(function () {
      return import('@/views/alliance/bills/index');
    }),
    name: 'AllianceMerchantBills',
    meta: {
      title: '账单中心',
      icon: ''
    }
  }]
};
export default allianceRouter;